var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-checkbox',{staticClass:"d-block",attrs:{"value":true,"unchecked-value":false},on:{"input":_vm.onChange},model:{value:(_vm.p_value),callback:function ($$v) {_vm.p_value=$$v},expression:"p_value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }